import DataService from "../../../services/client/classes/dataService";
import { IFilterApplicationList } from '../models/interfaces/applicationTrackingSystem/iFilterApplicationList'
import { IChangeApplicationStatusOutput } from "../models/interfaces/applicationTrackingSystem/iChangeApplicationStatusOutput";
import { ISendMessageOutput } from "../models/interfaces/applicationTrackingSystem/iSendMessageOutput";
import { IEditApplicationAnswersOutput } from "../models/interfaces/applicationTrackingSystem/iEditApplicationAnswersOutput";
import { IFeedback } from "../models/interfaces/applicationTrackingSystem/iFeedback";

class ApplicationTrackingSystemService extends DataService {
  constructor() {
  super('/private/database/applicationTrackingSystem/');
  }

  getApplicationList(filterApplicationList: IFilterApplicationList): JQuery.jqXHR<any> {
    return this.post('getApplicationList/', filterApplicationList);
  }

  getApplication(applicationKey: string): JQuery.jqXHR<any> {
    return this.get('getApplication/', { applicationKey });
  }

  changeApplicationStatus(data: IChangeApplicationStatusOutput): JQuery.jqXHR<any> {
    return this.post('changeApplicationStatus/', data);
  }

  editApplicationAnswers(data: IEditApplicationAnswersOutput): JQuery.jqXHR<any> {
    return this.post('editApplicationAnswers/', data);
  }

  sendMessage(data: ISendMessageOutput): JQuery.jqXHR<any> {
    return this.post('sendMessage/', data);
  }

  addFeedback(data: IFeedback): JQuery.jqXHR<any> {
    return this.post('addFeedback/', data);
  }
}

export default new ApplicationTrackingSystemService();


// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/applicationTrackingSystemService.ts